import { useEffect, useRef } from 'react';
import { joinInviteSegment } from '@/lib/api/joinInviteSegment';
import { isEmbedMode } from '@/lib/auth';
import { useAuth } from '@/pages/AuthContext';

// gloss
export const useJoinInviteSegment = (): void => {
  const { fetchToken, authCredentialsAvailable } = useAuth();
  const attemptedRef = useRef(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!authCredentialsAvailable() || isEmbedMode()) return;
    if (attemptedRef.current) return;

    const inviteTag = localStorage.getItem('inviteTag');
    if (!inviteTag) return;

    attemptedRef.current = true;

    const run = async () => {
      const token = await fetchToken();
      if (!token) return;

      const resolved = await joinInviteSegment(inviteTag, token);
      if (!resolved) return;

      localStorage.removeItem('inviteTag');
    };

    run();
  }, [authCredentialsAvailable, fetchToken]);
};
